export const NAV = [
  {
    group: "Daily Life: Costs & Burdens",
    items: [
      { id: "equity", label: "The Two Huntsvilles", emoji: "🏙️" },
      { id: "utilities", label: "Utilities: Power, Water, & Gas", emoji: "⚡" },
      { id: "health", label: "Healthcare & Hospital System", emoji: "🏥" },
      { id: "insurance_burdens", label: "Insurance Burdens", emoji: "💳" },
      { id: "workers_childcare", label: "Worker Rights & Child Care", emoji: "👷" },
      { id: "taxation", label: "Taxation", emoji: "💸" },
      { id: "housing_crisis", label: "Housing Crisis", emoji: "🏠" },
    ],
  },
  {
    group: "Accountability: Power & Public Oversight",
    items: [
      { id: "officials_elections", label: "Officials & Elections", emoji: "🗳️" },
      { id: "boards_oversight", label: "Boards, Directors, & School Boards", emoji: "🧩" },
      { id: "voting_rights", label: "The Ballot & Your Access", emoji: "📮" },
      { id: "criminal_justice", label: "Criminal Justice: Sentencing & Prisons", emoji: "⛓️" },
      { id: "policing", label: "Law Enforcement & Accountability", emoji: "🚔" },
      { id: "data_collection", label: "Surveillance & Data Collection", emoji: "👁️" },
      { id: "money", label: "Follow the Money", emoji: "💰" },
    ],
  },
  {
    group: "Systems: Harm & Change",
    items: [
      { id: "landuse", label: "Land: Annexation, Zoning, & Development", emoji: "🏗️" },
      { id: "environment", label: "Environment", emoji: "🌎" },
      { id: "information_warfare", label: "Information Warfare", emoji: "📢" },
      { id: "proposals", label: "A Better Huntsville: The Blueprint", emoji: "✨", featured: true },
    ],
  },
];

export const BOTTOM_NAV = { id: "action", label: "Take Action", emoji: "📬", group: "What You Can Do" };
